import moment from "moment";
import getGrnStatusLabelData from "utils/getGrnStatusLabelData";

const LastFrnGdn = ({ data }) => (
  <div className="dashboard-wrapper-flex">
    <div className="column-half">
      <div className="dashboard">
        <header className="dashboard__header dashboard__header--edit">
          <h2 className="dashboard__title heading">10 ostatnich dostaw</h2>
        </header>
        {data?.last_grn_lines?.length > 0 && (
          <ul className="logs-list">
            {data.last_grn_lines.map(
              ({
                id,
                quantity,
                deleted_at,
                grn: {
                  id: grn_id,
                  identifier,
                  prepared_at,
                  to_name,
                  status,
                  is_dispatched,
                },
              }) => {
                const label = getGrnStatusLabelData({
                  status,
                  is_dispatched,
                });
                const is_deleted = !!deleted_at;
                return (
                  <li
                    className={`logs-list__item ${is_deleted ? "danger" : ""}`}
                    key={id}
                  >
                    <div className="wrapper jc-sb ai-c">
                      <div>
                        {is_deleted && (
                          <p>
                            <span className="text-danger text-bold">
                              Brak w dostawie
                            </span>
                          </p>
                        )}
                        <p className="title">
                          {prepared_at
                            ? moment(prepared_at).format("DD-MM-YYYY HH:mm")
                            : ""}{" "}
                          {quantity} szt.
                        </p>
                        <p><strong>{to_name}</strong></p>
                        <p>
                          <a
                            className="link"
                            target="_blank"
                            href={`/grns/${grn_id}`}
                          >
                            {identifier}
                          </a>
                        </p>
                      </div>
                      <div>
                        <div
                          className={`status-label status-label--sm ${label.status}`}
                        >
                          <span>{label.status_text}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              }
            )}
          </ul>
        )}
      </div>
    </div>
    <div className="column-half">
      <div className="dashboard">
        <header className="dashboard__header dashboard__header--edit">
          <h2 className="dashboard__title heading">10 ostatnich zamówień</h2>
        </header>
        {data?.last_gdn_lines?.length > 0 && (
          <ul className="logs-list">
            {data.last_gdn_lines.map(
              ({
                id,
                quantity,
                gdn: { id: gdn_id, identifier, dispached_at },
              }) => (
                <li className="logs-list__item" key={id}>
                  <p className="title">
                    {dispached_at
                      ? moment(dispached_at).format("DD-MM-YYYY HH:mm")
                      : ""}{" "}
                    {quantity} szt.
                  </p>
                  <p>
                    <a
                      className="link"
                      target="_blank"
                      href={`/gdns/${gdn_id}`}
                    >
                      {identifier}
                    </a>
                  </p>
                </li>
              )
            )}
          </ul>
        )}
      </div>
    </div>
  </div>
);

export default LastFrnGdn;
